import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Car, Home, ArrowLeft } from "lucide-react";

const NotFoundPage = () => {
  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4">
      <div className="text-center max-w-md">
        <div className="w-20 h-20 bg-[#000091] rounded-full flex items-center justify-center mx-auto mb-6">
          <Car className="w-10 h-10 text-white" />
        </div>
        
        <h1 className="text-6xl font-bold text-[#000091] mb-4">404</h1>
        <h2 className="text-2xl font-semibold text-[#0F172A] mb-4">Page non trouvée</h2>
        <p className="text-slate-600 mb-8">
          Désolé, la page que vous recherchez n'existe pas ou a été déplacée.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link to="/">
            <Button className="bg-[#000091] hover:bg-[#000091]/90 w-full sm:w-auto">
              <Home className="w-4 h-4 mr-2" />
              Retour à l'accueil
            </Button>
          </Link>
          <Button 
            variant="outline" 
            onClick={() => window.history.back()}
            className="border-slate-300 w-full sm:w-auto"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Page précédente
          </Button>
        </div>
        
        <div className="mt-12 text-sm text-slate-500">
          <p>Vous cherchez peut-être :</p>
          <div className="flex flex-wrap gap-2 justify-center mt-3">
            <Link to="/demande" className="text-[#000091] hover:underline">Faire une demande</Link>
            <span>•</span>
            <Link to="/connexion" className="text-[#000091] hover:underline">Mon espace</Link>
            <span>•</span>
            <Link to="/guide/quitus-fiscal" className="text-[#000091] hover:underline">Guide Quitus</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
